export class GenericModal {
    constructor() {
        this.options = [];
        // object passed and to be return on cancel or continue events
        this.requesting = null;
    }
    titleLabel() {
        let title = '';
        switch (this.title) {
            case GenericModalTitle.Confirm: {
                title = 'Confirm';
                break;
            }
            case GenericModalTitle.Warning: {
                title = 'Warning';
                break;
            }
            case GenericModalTitle.Unsavedchanges: {
                title = 'Unsaved Changes';
                break;
            }
            case GenericModalTitle.CountsGenerating: {
                title = 'Counts Generating';
                break;
            }
            default: {
                title = 'Oops!';
                break;
            }
        }
        return title;
    }
    cancelLabel() {
        let cancel = '';
        switch (this.cancelButton) {
            case GenericModalCancelLabel.Cancel: {
                cancel = 'Cancel';
                break;
            }
            case GenericModalCancelLabel.Close: {
                cancel = 'Close';
                break;
            }
            case GenericModalCancelLabel.StayOnPage: {
                cancel = 'Stay On Page';
                break;
            }
            case GenericModalCancelLabel.No: {
                cancel = 'No';
                break;
            }
            default: {
                cancel = 'Oops!';
                break;
            }
        }
        return cancel;
    }
    continueLabel() {
        let continueL = '';
        switch (this.continueButton) {
            case GenericModalContinueLabel.Deactivate: {
                continueL = 'Deactivate';
                break;
            }
            case GenericModalContinueLabel.LeavePage: {
                continueL = 'Leave Page';
                break;
            }
            case GenericModalContinueLabel.ManageAudiences: {
                continueL = 'Manage Audience';
                break;
            }
            case GenericModalContinueLabel.Publish: {
                continueL = 'Publish';
                break;
            }
            case GenericModalContinueLabel.Save: {
                continueL = 'Save';
                break;
            }
            case GenericModalContinueLabel.Yes: {
                continueL = 'Yes';
                break;
            }
            case GenericModalContinueLabel.ViewCampaigns: {
                continueL = 'View Campaigns';
                break;
            }
            default: {
                continueL = 'Oops!';
                break;
            }
        }
        return continueL;
    }
}
export var GenericModalType;
(function (GenericModalType) {
    GenericModalType[GenericModalType["Custom"] = 0] = "Custom";
    GenericModalType[GenericModalType["UnsavedChanges"] = 1] = "UnsavedChanges";
    GenericModalType[GenericModalType["WithResponse"] = 2] = "WithResponse";
})(GenericModalType || (GenericModalType = {}));
export var GenericModalTitle;
(function (GenericModalTitle) {
    GenericModalTitle[GenericModalTitle["Confirm"] = 0] = "Confirm";
    GenericModalTitle[GenericModalTitle["Warning"] = 1] = "Warning";
    GenericModalTitle[GenericModalTitle["Unsavedchanges"] = 2] = "Unsavedchanges";
    GenericModalTitle[GenericModalTitle["CountsGenerating"] = 3] = "CountsGenerating";
})(GenericModalTitle || (GenericModalTitle = {}));
export var GenericModalCancelLabel;
(function (GenericModalCancelLabel) {
    GenericModalCancelLabel[GenericModalCancelLabel["Cancel"] = 0] = "Cancel";
    GenericModalCancelLabel[GenericModalCancelLabel["Close"] = 1] = "Close";
    GenericModalCancelLabel[GenericModalCancelLabel["StayOnPage"] = 2] = "StayOnPage";
    GenericModalCancelLabel[GenericModalCancelLabel["No"] = 3] = "No";
})(GenericModalCancelLabel || (GenericModalCancelLabel = {}));
export var GenericModalContinueLabel;
(function (GenericModalContinueLabel) {
    GenericModalContinueLabel[GenericModalContinueLabel["Deactivate"] = 0] = "Deactivate";
    GenericModalContinueLabel[GenericModalContinueLabel["Publish"] = 1] = "Publish";
    GenericModalContinueLabel[GenericModalContinueLabel["ManageAudiences"] = 2] = "ManageAudiences";
    GenericModalContinueLabel[GenericModalContinueLabel["Save"] = 3] = "Save";
    GenericModalContinueLabel[GenericModalContinueLabel["LeavePage"] = 4] = "LeavePage";
    GenericModalContinueLabel[GenericModalContinueLabel["Yes"] = 5] = "Yes";
    GenericModalContinueLabel[GenericModalContinueLabel["ViewCampaigns"] = 6] = "ViewCampaigns";
})(GenericModalContinueLabel || (GenericModalContinueLabel = {}));
//# sourceMappingURL=GenericModal.js.map